import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"

const SearchFadeIn = (props) => {
  const initialDelay = 50
  const initialDuration = 400
  const topPosition = 20
  const delay = props.delay || initialDelay
  const transitionDuration = props.transitionDuration || initialDuration
  const [state, setState] = useState({
    maxIsVisible: 0,
  })

  useEffect(() => {
    const count = React.Children.count(props.children)
    let opacity = 0
    const interval = setInterval(() => {
      opacity++
      if (opacity > count) clearInterval(interval)

      setState({ maxIsVisible: opacity })
    }, delay)
  }, [props.children, delay])

  return (
    <div className={props.className}>
      {React.Children.map(props.children, (child, identifier) => {
        return (
          <div
            className={props.childClassName}
            style={{
              transition: `opacity ${transitionDuration}ms, top ${transitionDuration}ms`,
              position: "relative",
              top: state.maxIsVisible > identifier ? 0 : topPosition,
              opacity: state.maxIsVisible > identifier ? 1 : 0,
            }}
          >
            {child}
          </div>
        )
      })}
    </div>
  )
}

SearchFadeIn.propTypes = {
  delay: PropTypes.number,
  transitionDuration: PropTypes.number,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  childClassName: PropTypes.string,
}

export default SearchFadeIn
